export default {
  addMonths(inDate, inMonths) {
    var CurrentDate = inDate;
    inDate.setMonth(inDate.getMonth() + inMonths);
    return CurrentDate;
  },

  getStageStyle(stage) {
    if (stage == "Finding") return "fas fa-search";
    if (stage == "Evaluating") return "fas fa-question";
    if (stage == "Negotiating") return "fas fa-handshake";
    if (stage == "Diligence") return "fas fa-check-double";
    if (stage == "Closing") return "fas fa-file-signature";
    if (stage == "Rehabbing") return "fas fa-paint-roller";
    if (stage == "Leasing") return "fas fa-users";
    if (stage == "Selling") return "fas fa-dollar-sign";
    if (stage == "Inactive") return "fas fa-stop-circle";
    return "";
  },

  parseISOString(s) {
    var b = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  },

  dateFormat(date) {
    return date;
  },

  getStages() {
    var stages = [
      "Finding",
      "Evaluating",
      "Negotiating",
      "Diligence",
      "Closing",
      "Rehabbing",
      "Leasing",
      "Selling",
      "Inactive"
    ];
    return stages;
  },

  formatBytes(a, b) {
    if (0 == a) return "0 Bytes";
    var c = 1024,
      d = b,
      e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      f = Math.floor(Math.log(a) / Math.log(c));
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
  },

  clone(original) {
    let clone = { ...original };
    return clone;
  },

  getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  },

  isMobile() {
    if (this.getWidth() < 400) return true;
    return false;
  },

  isTablet() {
    if (this.getWidth() > 400 && this.getWidth() <= 768) return true;
    return false;
  },

  isDesktop() {
    if (this.getWidth() >= 768) return true;
    return false;
  },

  isSuperWide() {
    if (this.getWidth() >= 1280) return true;
    return false;
  },

  getFontAwesomeIconFromMIME(mimeType) {
    // List of official MIME Types: http://www.iana.org/assignments/media-types/media-types.xhtml
    var icon_classes = {
      // Media
      image: "fa-file-image",
      audio: "fa-file-audio",
      video: "fa-file-video",
      // Documents
      "application/pdf": "fa-file-pdf",
      "application/msword": "fa-file-word",
      "application/vnd.ms-word": "fa-file-word",
      "application/vnd.oasis.opendocument.text": "fa-file-word",
      "application/vnd.openxmlformats-officedocument.wordprocessingml":
        "fa-file-word",
      "application/vnd.ms-excel": "fa-file-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml":
        "fa-file-excel",
      "application/vnd.oasis.opendocument.spreadsheet": "fa-file-excel",
      "application/vnd.ms-powerpoint": "fa-file-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml":
        "fa-file-powerpoint",
      "application/vnd.oasis.opendocument.presentation": "fa-file-powerpoint",
      "text/plain": "fa-file-text",
      "text/html": "fa-file-code",
      "application/json": "fa-file-code",
      // Archives
      "application/gzip": "fa-file-archive",
      "application/zip": "fa-file-archive"
    };

    for (var key in icon_classes) {
      if (icon_classes.hasOwnProperty(key)) {
        if (mimeType.search(key) === 0) {
          // Found it
          return icon_classes[key];
        }
      } else {
        return "fa-file";
      }
    }
  }
};
